import { ref, watch, type Ref } from 'vue';

export const useHoverLastColumn = (cloneHeight: Ref<number>) => {
  const lastColumnElement = ref<HTMLDivElement | null>(null);
  const prevLastColumnElement = ref<HTMLDivElement | null>(null);
  const gridRef = ref<HTMLElement | null>(null);

  const addRef = (refData: HTMLElement | null) => {
    gridRef.value = refData;
    const gridElement = gridRef?.value?.querySelectorAll('.modern-grid-header__cell');
    const draggableElements = Array.from(gridElement ?? []).filter(
      (el) => !!(el as HTMLElement)?.className.includes('resizable'),
    );
    lastColumnElement.value =
      (draggableElements?.[draggableElements.length - 1] as HTMLDivElement) || null;
  };

  const handleMouseOver = (event: MouseEvent) => {
    if ((event.target as HTMLElement).className === 'modern-grid-header__resize-handle') return;
    const el = gridRef.value;
    if (el && el.scrollHeight <= el.clientHeight) {
      return;
    }
    const tempLine = el?.querySelector('.modern-grid-header__resize-handle-mirror');
    if (tempLine) {
      let clone = tempLine.parentElement?.querySelector(
        '.modern-grid-header__resize-handle-mirror-clone',
      ) as HTMLElement;
      if (!clone) {
        clone = tempLine.cloneNode(true) as HTMLElement;
        clone.classList.add('modern-grid-header__resize-handle-mirror-clone');
        tempLine.parentElement?.appendChild(clone);
      }
      clone.style.display = 'block';
      clone.style.height = `${cloneHeight.value}px`;
      clone.style.left = `${(event.currentTarget as HTMLElement).offsetLeft + (event.currentTarget as HTMLElement).offsetWidth - 1}px`;
    }
  };

  const handleMouseLeave = (event: MouseEvent) => {
    if ((event.target as HTMLElement).className === 'modern-grid-header__resize-handle') return;
    const cloneLine = gridRef.value?.querySelector(
      '.modern-grid-header__resize-handle-mirror-clone',
    ) as HTMLElement;
    if (cloneLine) {
      cloneLine.style.display = 'none';
    }
  };

  const removeEventListenersFromElement = (element: HTMLElement | null) => {
    if (!element) return;
    element.removeEventListener('mouseover', handleMouseOver);
    element.removeEventListener('mouseleave', handleMouseLeave);
  };

  const removeLastColumnEvents = () => {
    // 현재 lastColumnElement의 이벤트 리스너 제거
    removeEventListenersFromElement(lastColumnElement.value);

    // prevLastColumnElement도 이벤트 리스너 제거 (다른 element인 경우)
    if (prevLastColumnElement.value && prevLastColumnElement.value !== lastColumnElement.value) {
      removeEventListenersFromElement(prevLastColumnElement.value);
    }
  };

  const addLastColumnEvents = () => {
    if (!lastColumnElement.value) return;
    if (prevLastColumnElement.value) {
      removeEventListenersFromElement(prevLastColumnElement.value);
    }

    // 기존에 표시된 clone 숨김
    const existingClone = gridRef.value?.querySelector(
      '.modern-grid-header__resize-handle-mirror-clone',
    ) as HTMLElement;
    if (existingClone) {
      existingClone.style.display = 'none';
    }

    prevLastColumnElement.value = lastColumnElement.value;
    lastColumnElement.value.addEventListener('mouseover', handleMouseOver);
    lastColumnElement.value.addEventListener('mouseleave', handleMouseLeave);
  };

  watch(cloneHeight, (newHeight) => {
    const clone = gridRef.value?.querySelector(
      '.modern-grid-header__resize-handle-mirror-clone',
    ) as HTMLElement;
    if (clone && clone.style.display === 'block') {
      clone.style.height = `${newHeight}px`;
    }
  });

  return {
    addLastColumnEvents,
    removeLastColumnEvents,
    addRef,
  };
};
